angular.module("FlexyBeautyApp.services")
    .factory("LaunchDarklyFeatureFlagList", [function () {
        return {
            FLEX_3279_FEATURE_FLAG_BACKOFFICE_CUSTOMER: {
                flagName: "flex-3279-backoffice-customer"
            },
            FLEX_3534_FEATURE_FLAG_LE_CISEAU_SERVICE_SETTINGS: {
                flagName: "flex-3534-le-ciseau-service-settings"
            },
            FLEX_3477_FEATURE_FLAG_DRAG_DROP: {
                flagName: "flex-3477-drag-drop"
            },
            FLEX_3775_FEATURE_FLAG_NEW_LOADING: {
                flagName: "flex-3775-new-loading"
            },
            FLEX_4365_FEATURE_FLAG_BOOKING_USER_STORY: {
                flagName: "flex-4365-booking-user-story"
            },
            FLEX_4424_FEATURE_FLAG_KIUTE_PRO_APP: {
                flagName: 'flex-4424-kiute-pro-app'
            },
            FLEX_311_FORCE_MIGRATION_INFOS: {
                flagName: 'flex-311-force-migration-infos'
            },
            FLEX_364_FORCE_MIGRATION_DATE: {
                flagName: 'flex-364-force-migration-date'
            },
            FLEX_287_DOUBLE_TAB_BLOCKED: {
                flagName: 'flex-287-double-tab-blocked'
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/tools/LaunchDarklyFeatureFlagList.js